import React, { useState, lazy, Suspense } from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { MenuBook } from '@mui/icons-material';
import { vortxTypography } from '@vortx/shared-ui';
import { COLORS } from '../results/ResultsDesignTokens';
import WikiToc from './WikiToc';
import WikiContent from './WikiContent';
import { WIKI_SECTIONS, getPageContent, getPageMeta, DEFAULT_PAGE_ID } from '../../../wiki/manifest';

const ArchitectureMap = lazy(() => import('./architecture-map/ArchitectureMap'));

const accentColor = '#9b59b6';

// Registry of component pages (pageId → lazy component)
const COMPONENT_PAGES = {
    'arch-platform-map': ArchitectureMap,
};

const WikiSection = () => {
    const [activePage, setActivePage] = useState(DEFAULT_PAGE_ID);
    const content = getPageContent(activePage);
    const pageMeta = getPageMeta(activePage);
    const isComponentPage = pageMeta?.component && COMPONENT_PAGES[activePage];
    const ComponentPage = isComponentPage ? COMPONENT_PAGES[activePage] : null;

    return (
        <Box>
            {/* Header */}
            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1.5,
                mb: 3,
            }}>
                <MenuBook sx={{
                    fontSize: 22,
                    color: accentColor,
                    filter: `drop-shadow(0 0 6px ${accentColor})`,
                }} />
                <Typography sx={{
                    fontFamily: vortxTypography.heading,
                    fontSize: '1.2rem',
                    fontWeight: 700,
                    color: COLORS.text.primary,
                    textShadow: `0 0 20px ${accentColor}40`,
                }}>
                    Wiki
                </Typography>
            </Box>

            {/* Two-column layout */}
            <Box sx={{
                display: 'flex',
                backgroundColor: COLORS.bg.card,
                borderRadius: '8px',
                border: `1px solid ${accentColor}15`,
                minHeight: 'calc(100vh - 200px)',
                overflow: 'hidden',
            }}>
                <WikiToc
                    sections={WIKI_SECTIONS}
                    activePage={activePage}
                    onPageSelect={setActivePage}
                />
                <Box sx={{ flex: 1, overflowY: isComponentPage ? 'hidden' : 'auto', maxHeight: 'calc(100vh - 200px)' }}>
                    {isComponentPage ? (
                        <Suspense fallback={
                            <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                                <CircularProgress size={24} sx={{ color: accentColor }} />
                            </Box>
                        }>
                            <ComponentPage />
                        </Suspense>
                    ) : (
                        <WikiContent markdown={content} />
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default WikiSection;
